import React from 'react';
import bgImg from '../images/services-hero-img.png';
import Button from '../Button/Button';
import HeroGradient from '../gradientBg/HeroGradient';

export default function ServiceHero({title, para}) {
  return (
    <div className='flex flex-col items-center mt-[115px] md:mt-0 md:pt-32   justify-center text-center gap-14 font-poppins w-full relative md:h-[98vh]'>
      {/* Only show the background image on desktop */}
      <div 
        className="hidden md:flex absolute opacity-20 inset-0 w-full h-full bg-cover bg-center z-10" 
        style={{ backgroundImage: `url(${bgImg})` }} 
      ></div>

      {/* Mobile-specific image (hidden on desktop) */}
      <img src={bgImg} alt="Service Hero" className="md:hidden w-full opacity-80 h-auto z-10" />

      {/* Gradient Overlay */}
      <HeroGradient />

      {/* Text and Button (common for both desktop and mobile) */}
      <div className="relative max-w-[99%] md:max-w-[80%] z-10 px-4 flex items-center justify-center flex-col">
        <p className="font-semibold text-[28px] md:text-[40px] bg-clip-text text-transparent bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
{title}
        </p>
        <p className="font-montserrat text-white text-center tracking-wider text-base md:text-2xl mt-4 md:max-w-[87%] mx-auto">
        {para}</p>
        <div className="mt-6">
          <Button title={"Get Started"} />
        </div>
      </div>
    </div>
  );
}
